"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Such-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} [options.label=Suche] Labeltext
 * @param {function} options.keyup Callback die bei der Eingabe eines Buchstabens im Suchfeld aufgerufen wird
 * @param {function} options.reset Callback die beim Klick auf "Zurücksetzen" aufegrufen wird
 */
gc.gis.widget.GCSearch = function( options )
{
	this.label              = options.label || 'Suche';
	this.onKeyup            = options.keyup;
	this.onReset            = options.reset;

	gc.gis.widget.GCWidget.call(this, options);
};
gc.gis.widget.GCSearch.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * Setzt die aktuelle Eingabe des Steuerelemets zurück.
 *
 * @method
 * @public
 */
gc.gis.widget.GCSearch.prototype.reset = function()
{
	this.element_search_input.val('');
};

/**
 * Setzt die aktuelle Eingabe des Steuerelemets zurück.
 *
 * @method
 * @return {jQuery}
 * @private
 */
gc.gis.widget.GCSearch.prototype._render = function()
{
	var self = this;

	this.element_search_input = jQuery('<input>', {
		type: 'text',
		'class': 'form-control control-input',
		keyup: function(evt)
		{
			if (typeof self.onKeyup === 'function')
			{
				var key = evt.keyCode || evt.which;
				var val = jQuery(this).val();

				// tab, enter, shift, ctrl, alt, pause/break, caps, escape, page up/down, end, home, arrow keys
				if((key < 9 || key > 40) || key === 13)
				{
					self.onKeyup.call(self, val, evt);
				}
			}
		}
	});

	var element_search_reset = jQuery('<input>', {
		type: 'reset',
		'class': 'gc-control-reset btn btn-default',
		value: 'X',
		title: 'Zurücksetzen',
		click: function(evt)
		{
			evt.preventDefault();
			if (typeof self.onReset === 'function')
			{
				self.onReset.call(self, evt);
			}
			else
			{
				self.reset();
			}
			jQuery(this).blur();
		}
	});

	var element_search = jQuery('<label>', {
		'class': 'gc-widget gc-widget-item gc-widget-search input-group' + (this.className ? ' ' + this.className : ''),
		html: '<span class="input-group-addon">' + this.label + '</span>'
	});
	element_search.append(' ').append(this.element_search_input)
		.append(' ').append( jQuery('<span>', {
		'class': 'input-group-btn',
		html: element_search_reset
	}) );
	gc.gis.iface.ui.tooltip(element_search_reset);

	return element_search;
};

